module.exports = __webpack_public_path__ + "4cbaee6efe20a7582fb5f9a1de427ca1.pdf";